// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__33RdX","rightAdornment":"Header_rightAdornment__1kaiV"};